<template>
  <!-- Original expansion panel structure - commented out -->
  <!-- <v-expansion-panel class="ma-1 h-100 d-flex flex-column">
    <template v-slot:title>
        <v-card class="elevation-0 bg-transparent flex-grow-0">                                           
            <div class="card-title">{{ card.title}}</div>
            <div class="card-subtitle">{{ card.subtitle }}</div>
        </v-card>
    </template>
    <template v-slot:text>
        <v-container class="flex-grow-1 d-flex flex-column">
            <v-row class="flex-grow-0">
                <v-img
                    :src="card.bannerURL"
                    cover
                    height="100px"
                ></v-img>  
            </v-row>                                       
            
            <v-row class="flex-grow-1">
                <v-toolbar border density="compact" v-for="action in card.actions" class="flex-grow-0">
                    <v-toolbar-title class="toolbar-title" :text="action.title"></v-toolbar-title>

                    <template v-slot:append>
                        <div class="d-flex ga-1">
                            <v-btn v-if="action.hasPreview === true" density="compact" icon @click="openPreview(action.assetURL)">
                              <v-tooltip
                                activator="parent"
                                location="top"
                              >Preview</v-tooltip>
                              <v-icon class="toolbar-button">
                                mdi-eye-outline
                              </v-icon>
                            </v-btn>
                        
                            <v-btn v-if="action.hasEmbed === true" density="compact" icon @click="openScript(action.embedCode, 'Embed Script')">
                              <v-tooltip
                                activator="parent"
                                location="top"
                              >Embed Script</v-tooltip>     
                              <v-icon class="toolbar-button">
                                mdi-xml
                              </v-icon>                                                               
                            </v-btn>

                            <v-btn v-if="action.hasLink === true" density="compact" icon @click="openScript(action.assetURL, 'Asset URL')">
                              <v-tooltip
                                activator="parent"
                                location="top"
                              >Asset URL</v-tooltip>     
                              <v-icon class="toolbar-button">
                                mdi-link
                              </v-icon>                                                               
                            </v-btn>
                            
                            <v-btn v-if="action.hasDownload === true" density="compact" icon @click="download(action.assetURL)">
                              <v-tooltip
                                activator="parent"
                                location="top"
                              >Download</v-tooltip>
                              <v-icon class="toolbar-button">
                                mdi-download
                              </v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-toolbar>                
            </v-row>
    
        </v-container>                                        
    </template>                                  
  </v-expansion-panel> -->

  <!-- New regular card structure -->
  <v-card class="mx-1 h-100 d-flex flex-column" role="article" :aria-label="`Marketing asset: ${card.title}`">
    <!-- Image section -->
    <v-card-media class="flex-grow-0">
      <v-img
          :src="card.bannerURL"
          :alt="`Banner image for ${card.title}`"
          
          height="150px"
      ></v-img>
        <!-- contain if blur is bad -->
    </v-card-media>
    
    <!-- Title and subtitle section -->
    <v-card-title class="flex-grow-0 pa-4">
      <div class="card-title">{{ card.title}}</div>
      <div class="card-subtitle" :style="{ minHeight: subtitleMinHeight, maxHeight: subtitleMaxHeight }">{{ card.subtitle }}</div>
    </v-card-title>
    
    <!-- Buttons section -->
    <v-card-text class="flex-grow-1 d-flex flex-column pa-0">
      <div class="flex-grow-1"></div>
      <v-toolbar border density="compact" v-for="action in card.actions" class="flex-grow-0">
          <v-toolbar-title class="toolbar-title" :text="action.title"></v-toolbar-title>

          <template v-slot:append>
              <div class="d-flex ga-1">
                  <v-btn v-if="action.hasPreview === true" density="compact" icon @click="openPreview(action.assetURL)" 
                         :aria-label="`Preview ${action.title}`" tabindex="0" @keydown.enter="openPreview(action.assetURL)" @keydown.space="openPreview(action.assetURL)">
                    <v-tooltip
                      activator="parent"
                      location="top"
                    >Preview</v-tooltip>
                    <v-icon class="toolbar-button" aria-hidden="true">
                      mdi-eye-outline
                    </v-icon>
                  </v-btn>
              
                  <v-btn v-if="action.hasEmbed === true" density="compact" icon @click="openScript(action.embedCode, 'Embed Script')" 
                         :aria-label="`Get embed script for ${action.title}`" tabindex="0" @keydown.enter="openScript(action.embedCode, 'Embed Script')" @keydown.space="openScript(action.embedCode, 'Embed Script')">
                    <v-tooltip
                      activator="parent"
                      location="top"
                    >Embed Script</v-tooltip>     
                    <v-icon class="toolbar-button" aria-hidden="true">
                      mdi-xml
                    </v-icon>                                                               
                  </v-btn>

                  <v-btn v-if="action.hasLink === true" density="compact" icon @click="openScript(action.assetURL, 'Asset URL')" 
                         :aria-label="`Get asset URL for ${action.title}`" tabindex="0" @keydown.enter="openScript(action.assetURL, 'Asset URL')" @keydown.space="openScript(action.assetURL, 'Asset URL')">
                    <v-tooltip
                      activator="parent"
                      location="top"
                    >Asset URL</v-tooltip>     
                    <v-icon class="toolbar-button" aria-hidden="true">
                      mdi-link
                    </v-icon>                                                               
                  </v-btn>
                  
                  <v-btn v-if="action.hasDownload === true" density="compact" icon @click="download(action.assetURL)" 
                         :aria-label="`Download ${action.title}`" tabindex="0" @keydown.enter="download(action.assetURL)" @keydown.space="download(action.assetURL)">
                    <v-tooltip
                      activator="parent"
                      location="top"
                    >Download</v-tooltip>
                    <v-icon class="toolbar-button" aria-hidden="true">
                      mdi-download
                    </v-icon>
                  </v-btn>
              </div>
          </template>
      </v-toolbar>                
    </v-card-text>                                        
  </v-card>

  <v-dialog v-model="showScript" width="350" scrollable role="dialog" :aria-labelledby="`dialog-title-${scriptTitle}`">
      <v-card role="document">
          <v-toolbar>
              <v-toolbar-title :id="`dialog-title-${scriptTitle}`">{{ scriptTitle }}</v-toolbar-title>
              <template v-slot:append>
                  <v-btn density="compact" icon @click="writeClipboardText" 
                         aria-label="Copy to clipboard" tabindex="0" @keydown.enter="writeClipboardText" @keydown.space="writeClipboardText">
                      <v-tooltip
                          activator="parent"
                          location="top"
                      >Copy</v-tooltip>
                      <v-icon class="toolbar-button" aria-hidden="true">
                          mdi-content-copy
                      </v-icon>
                  </v-btn>
              </template>
          </v-toolbar>
          <v-card-text class="pa-4" :aria-label="`Content for ${scriptTitle}`">
            {{ script }}
          </v-card-text>
          <v-card-actions class="border-t-thin">
              <v-btn @click="showScript = false" width="100" aria-label="Close dialog" tabindex="0" @keydown.enter="showScript = false" @keydown.space="showScript = false">Close</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>

</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  cardContent: { type: {} },
  subtitleMinHeight: { type: String, default: '60px' },
  subtitleMaxHeight: { type: String, default: '60px' }
})

// Make card reactive to prop changes
const card = computed(() => props.cardContent)

const showScript = ref(false)
const script = ref('')
const scriptTitle = ref('')

const openPreview = (url) => {
  window.open(url, '_blank').focus()
}

const openScript = (code, title) => {
  script.value = code
  scriptTitle.value = title
  showScript.value = true
}

const download = async (url) => {
  window.open(url).focus()
 
}


const writeClipboardText = async () => {
  try {
    await navigator.clipboard.writeText(script.value)
  } catch (error) {
    console.error(error.message);
  }
}
</script>

<style scoped>

.card-title {
    background-color: transparent;
    font-size: 14px;
    font-weight: 500;
    color: #222c2c;
    padding-bottom: 5px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    overflow-y: auto;
}

.card-subtitle {
    background-color: transparent;
    font-size: 12px;
    font-weight: 400;
    color: #8f8f8f;
    padding-bottom: 0;
    line-height: 1.2;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    overflow-y: auto;
}

.toolbar-title {
    background-color: transparent;
    font-size: 12px;
    font-weight: 500;
    color: #252424;
}

.toolbar-button {
    color: #85133F;
}

/* Original expansion panel styles - commented out */
/* :deep(.v-expansion-panel) {
    height: 100%;
    display: flex;
    flex-direction: column;
}

:deep(.v-expansion-panel-text__wrapper) {
    flex: 1;
    display: flex;
    flex-direction: column;
}

:deep(.v-expansion-panel-text) {
    flex: 1;
    display: flex;
    flex-direction: column;
} */

/* New regular card styles */
:deep(.v-card) {
    height: 100%;
    display: flex;
    flex-direction: column;
}

:deep(.v-card-media) {
    flex-shrink: 0;
}

:deep(.v-card-title) {
    flex-shrink: 0;
    padding: 16px;
}

:deep(.v-card-text) {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0;
}
</style>